<template>
  <div>
    <card-toolbar
      icon="highlight_off"
      title="404"
    />

    <v-row class="pa-4">
      <h1>{{ $tc('not_implemented') }}</h1>
    </v-row>
  </div>
</template>

<script>
import CardToolbar from '@/components/CardToolbar'
export default {
  components: { CardToolbar }
}
</script>
